import { ShallowRef } from 'vue'

import { RAW_PUBLISH_SETTLE_MS } from './raw-publish-settle'
import { reapplyBackgroundBlurOnActiveSessions } from './reapply-background-blur-on-sessions'

type SessionLike = {
  connection: RTCPeerConnection
  data?: { trackForAdd?: MediaStreamTrack }
}

const delay = (ms: number) => new Promise<void>((resolve) => {
  window.setTimeout(resolve, ms)
})

/**
 * After raw camera publish, apply blur via the shared reapply queue.
 *
 * Delayed on purpose: attaching canvas.captureStream too soon after conference
 * unmute/replaceTrack causes ~30s freezes for remotes.
 */
export const upgradePublishedWebcamToBackgroundBlur = async (
  _session: SessionLike,
  streamRef: ShallowRef<MediaStream | undefined>,
): Promise<void> => {
  const published = streamRef.value
  if (!published) return

  await delay(RAW_PUBLISH_SETTLE_MS)

  // Camera turned off / replaced while we waited for SFU to latch onto raw video.
  if (streamRef.value !== published) return

  await reapplyBackgroundBlurOnActiveSessions()
}
